// GetPageMetaData returns the meta data for a coupon landing page page.
export const CouponLandingPageMetaService_GetPageMetaDataLazy = () =>
  import("./service.grpc").then(
    (m) => m.CouponLandingPageMetaService_GetPageMetaData
  );
CouponLandingPageMetaService_GetPageMetaDataLazy.method =
  "aysa_api.services.coupons.v1.landingpage.meta.CouponLandingPageMetaService/GetPageMetaData" as const;
